export default "__VITE_ASSET__6vwzqGzU__"